"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const TableCell_1 = __importDefault(require("@mui/material/TableCell"));
const Checkbox_1 = __importDefault(require("@mui/material/Checkbox"));
const TableAccountRow = (props) => {
    const { columns, classes, account, onChangeAccountsToShow, selected } = props;
    const onCheckboxChange = (0, react_1.useCallback)(() => onChangeAccountsToShow(account.id), [onChangeAccountsToShow, account]);
    return (<TableRow_1.default className={classes.tableBodyRow} onClick={onCheckboxChange}>
      {Object.keys(columns).map((key) => {
            let cell;
            switch (key) {
                case 'checkBoxCol':
                    cell = (<div className={classes.checkBoxColContainer}>
                <Checkbox_1.default color="default" checked={selected} inputProps={{ 'aria-labelledby': `check-account-${account.id}` }}/>
              </div>);
                    break;
                case 'accountCol':
                    cell = <div className={classes.accountColContainer}>{account.name}</div>;
                    break;
                case 'typeCol':
                    cell = <div className={classes.typeColContainer}>{account.type}</div>;
                    break;
                case 'descriptionCol':
                    cell = <div className={classes.descriptionColContainer}>{account.description}</div>;
                    break;
                default: break;
            }
            return (<TableCell_1.default key={`cell-${account.id}-${key}`} className={(0, classnames_1.default)(classes.tableBodyCell, classes === null || classes === void 0 ? void 0 : classes[key])}>
            {cell}
          </TableCell_1.default>);
        })}
    </TableRow_1.default>);
};
exports.default = react_1.default.memo(TableAccountRow);
